import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    ICredentialStore,
    ModalResultType,
} from '@models';

@Component({
    templateUrl: './credential-store-delete.modal.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CredentialStoreDeleteModalComponent
    extends UiModalComponent<ICredentialStore> {
    public onConfirm() {
        this._dialogRef.close({
            type: ModalResultType.Succeeded,
        });
    }
}
